import SidebarSectionHeader from './SidebarSectionHeader'

export default SidebarSectionHeader
